import React from 'react';

import { FaArrowLeft } from 'react-icons/fa';
import "./NavigationBar.css"

interface Item {
    value: number;
    text: string;
    hide?: boolean;
    large_only?: boolean;
}

const NavigationBar: React.FC<{items: Item[], active: number, onChange: (value: number)=> void, onBack?: (event: React.MouseEvent<HTMLDivElement>)=> void}> = (props) => {
  return (
        <div className="nav-container">
            {props.onBack && (
                <div onClick={props.onBack} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', marginLeft: '7px', marginRight: '7px'}}>
                    <FaArrowLeft style={{ marginRight: '5px' }}/> Back
                </div>
            )}
            {props.items.map((item, index) => (
                item.hide ? null :
                    <div className={`p-2 nav-item ${item.value === props.active ? 'active' : ''} ${item.large_only ? 'large-screen-only' : ''}`}
                        onClick={() => props.onChange(item.value)} key={index}>
                        {item.text}
                    </div>
            ))}
        </div>
  );
};

export default NavigationBar;
